/**
 * Build API query string for unauthenticated pulse survey calls.
 * Prefer the browser's signed search (includes psx_*); fall back to identity params only for tests.
 *
 * @param {string | null | undefined} signedSearch - `window.location.search` or equivalent
 * @param {{ companyID?: string | null, employeeID?: string | null, campaignID?: string | null, questionDate?: string | null }} [fallback]
 * @returns {string} Query string including leading `?`, or empty string
 */
export function buildUnauthenticatedPulseSurveyQuery(signedSearch, fallback = {}) {
  const raw = typeof signedSearch === 'string' ? signedSearch.trim() : '';
  if (raw) {
    const withQ = raw.startsWith('?') ? raw : `?${raw}`;
    if (withQ.length > 1) {
      return withQ;
    }
  }

  const params = new URLSearchParams();
  if (fallback.companyID != null && fallback.companyID !== '') {
    params.set('companyID', String(fallback.companyID));
  }
  if (fallback.employeeID != null && fallback.employeeID !== '') {
    params.set('employeeID', String(fallback.employeeID));
  }
  if (fallback.campaignID != null && fallback.campaignID !== '') {
    params.set('campaignID', String(fallback.campaignID));
  }
  if (fallback.questionDate != null && fallback.questionDate !== '') {
    params.set('questionDate', String(fallback.questionDate));
  }
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}
